<template>
  <div class="bussiness">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'业务审批'}]"></breadcrumb>
    <div class="bussiness-wrap">
      <div class="bussiness-contain">
        <public-top-nav>
          <div>
            <span>审核状态</span>
            <el-select
              style="width:90px; margin-right:25px;margin-left:15px;"
              @change="getList()"
              v-model="params.status"
              clearable
            >
              <el-option label="待审批" :value="0"></el-option>
              <el-option label="已通过" :value="1"></el-option>
              <el-option label="已驳回" :value="2"></el-option>
              <el-option label="已读" :value="3"></el-option>
              <el-option label="已批示" :value="4"></el-option>
            </el-select>
            <el-input
              style="width:140px"
              clearable
              v-model="params.searchName"
              @keyup.enter.native="getList()"
              placeholder="请输入"
            ></el-input>
          </div>
        </public-top-nav>
        <div class="bussiness-table-wrap">
          <div class="bussiness-table">
            <table>
              <tr v-for="item in processList" :key="item.id">
                <td @click="showDetail(item.id)">{{item.name}}</td>
                <td>{{item.applyPeopleName}}</td>
                <td style="text-align:right">
                  <div v-if="item.status===0" style="color:#9B9B9B">
                    <font-awesome-icon
                      style="margin-right:6px;  cursor:pointer"
                      :icon="['fas', 'exclamation-circle']"
                    />待审批
                  </div>
                  <div v-else-if="item.status===1" style="color:#39B54A">
                    <font-awesome-icon
                      style="margin-right:6px;  cursor:pointer"
                      :icon="['fas', 'check-circle']"
                    />已通过
                  </div>
                  <div v-else-if="item.status===2" style="color:#F56C6C">
                    <font-awesome-icon
                      style="margin-right:6px;  cursor:pointer"
                      :icon="['fas', 'times-circle']"
                    />已驳回
                  </div>
                  <div v-else-if="item.status===3" style="color:#39B54A">
                    <font-awesome-icon
                      style="margin-right:6px;  cursor:pointer"
                      :icon="['fas', 'check-circle']"
                    />已读
                  </div>
                  <div v-else-if="item.status===4" style="color:#39B54A">
                    <font-awesome-icon
                      style="margin-right:6px;  cursor:pointer"
                      :icon="['fas', 'check-circle']"
                    />已批示
                  </div>
                </td>
                <td style="text-align:right">{{item.createTime.replace('T',' ')}}</td>
                 <td style="text-align:right;width:90px;color:#e97e00"><a style="color:#e97e00" v-if="item.fileUrlFinal" :href="item.fileUrlFinal"  :download="item.fileUrlFinal">归档文档下载</a></td>
                 <td style="text-align:right; width:90px; padding-left:0px;color:#e97e00"><a style="color:#e97e00" v-if="item.fileUrlOriginal"  :href="item.fileUrlOriginal"  :download="item.fileUrlOriginal" >原始文档下载</a></td>
              </tr>
            </table>
          </div>
          <el-pagination
            @current-change="changePage"
            :current-page="params.current"
            class="bussiness-pagination"
            background
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!--请假申请表-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template6"
      class="template_dialog"
      :visible="formShow===6"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>考勤申请表</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">姓名</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">所属部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">日常考勤申请</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">类型</div>
          <div
            class="template_dialog-item"
            v-if="templateContent.leaveType"
          >{{templateContent.leaveType|leaveTypeFilter}}</div>
          <div class="template_dialog-item" v-else>-</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">请假日期</div>
          <div
            class="template_dialog-item"
          >{{templateContent.startTime?(templateContent.startTime.split('T')[0] + ' 至 ' + templateContent.endTime.split('T')[0]):'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">休假申请</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">休假天数</div>
          <div class="template_dialog-item">{{templateContent.annualDays||'-'}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">尚余天数</div>
          <div class="template_dialog-item">{{templateContent.annualRemainDays||'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">休假时间</div>
          <div
            class="template_dialog-item"
          >{{templateContent.annualStartLeaveTime?(templateContent.annualStartLeaveTime.split('T')[0]+ ' 至 ' + templateContent.annualEndLeaveTime.split('T')[0]):'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">休假期间工作安排</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item left">{{templateContent.remark}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item_img">
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList" :key="item.id">
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >{{item.name}}</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >
            <img v-if="signList.length>index+1" :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >签署日期</div>
          <div class="template_dialog-item" :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allow" :loading="dialogLoading">通 过</el-button>
        <el-button @click="noallow" :loading="dialogLoading">驳 回</el-button>
      </div>
    </el-dialog>
    <!--交际应酬申请表-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template1"
      class="template_dialog"
      :visible="formShow===1"
    >
      >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>交际应酬费申请表（本市或外埠）</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">职位</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">应酬日期</div>
          <div class="template_dialog-item">{{templateContent.yingchouTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">总人数</div>
          <div class="template_dialog-item">{{templateContent.pepleNum}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">应酬单位</div>
          <div class="template_dialog-item">{{templateContent.yingchouUnit}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">应酬地点</div>
          <div class="template_dialog-item">{{templateContent.yingchouPlace}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">预计金额</div>
          <div class="template_dialog-item">{{templateContent.money}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">应酬目的</div>
          <div class="template_dialog-item left">{{templateContent.yingchouPurpose}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">活动内容</div>
          <div class="template_dialog-item left">{{templateContent.remark}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">嘉宾姓名</div>
          <div class="template_dialog-item">嘉宾职务</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">内陪人员姓名</div>
          <div class="template_dialog-item">职位</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.activities" :key="'1'+index">
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">{{item.name}}</div>
          <div class="template_dialog-item">{{item.duty}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">{{item.neipei}}</div>
          <div class="template_dialog-item">{{item.neipeiDuty}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请日期</div>
          <div
            class="template_dialog-item"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList" :key="item.id">
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >{{item.name}}</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >
            <img v-if="signList.length>index+1" :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >签署日期</div>
          <div class="template_dialog-item" :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allow" :loading="dialogLoading">通 过</el-button>
        <el-button @click="noallow" :loading="dialogLoading">驳 回</el-button>
      </div>
    </el-dialog>
    <!--办公用品领用表-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template2"
      class="template_dialog"
      :visible="formShow===2"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>办公用品领用表</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">办公室用品名称</div>
          <div class="template_dialog-item">规格</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">成本归属</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.officeSupplies" :key="'2'+index">
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">{{item.name}}</div>
          <div class="template_dialog-item">{{item.specification}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item">{{item.count}}</div>
          <div class="template_dialog-item">{{item.costCenter}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请日期</div>
          <div
            class="template_dialog-item"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList" :key="item.id">
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >{{item.name}}</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >
            <img v-if="signList.length>index+1" :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >签署日期</div>
          <div class="template_dialog-item" :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allow" :loading="dialogLoading">通 过</el-button>
        <el-button @click="noallow" :loading="dialogLoading">驳 回</el-button>
      </div>
    </el-dialog>
    <!--外购礼品申请表-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template4"
      class="template_dialog"
      :visible="formShow===4"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>外购礼品申请表</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item">礼品名称</div>
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">预算</div>
          <div class="template_dialog-item">赠送嘉宾</div>
          <div class="template_dialog-item">嘉宾单位</div>
          <div class="template_dialog-item">嘉宾职位</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.giftList" :key="'4'+index">
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item">{{item.giftName}}</div>
          <div class="template_dialog-item">{{item.count}}</div>
          <div class="template_dialog-item">{{item.money}}</div>
          <div class="template_dialog-item">{{item.guestName}}</div>
          <div class="template_dialog-item">{{item.guestCompany}}</div>
          <div class="template_dialog-item">{{item.guestDuty}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请日期</div>
          <div
            class="template_dialog-item"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList" :key="item.id">
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >{{item.name}}</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >
            <img v-if="signList.length>index+1" :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >签署日期</div>
          <div class="template_dialog-item" :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allow" :loading="dialogLoading">通 过</el-button>
        <el-button @click="noallow" :loading="dialogLoading">驳 回</el-button>
      </div>
    </el-dialog>
    <!--自制礼品申请表-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template5"
      class="template_dialog"
      :visible="formShow===5"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>自制礼品领用表</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请人</div>
          <div class="template_dialog-item">{{templateContent.peopleName}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">部门</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">职务</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item">礼品名称</div>
          <div class="template_dialog-item">数量</div>
          <div class="template_dialog-item">预算</div>
          <div class="template_dialog-item">赠送嘉宾</div>
          <div class="template_dialog-item">嘉宾单位</div>
          <div class="template_dialog-item">嘉宾职位</div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in templateContent.giftList" :key="'5'+index">
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item">{{item.giftName}}</div>
          <div class="template_dialog-item">{{item.count}}</div>
          <div class="template_dialog-item">{{item.money}}</div>
          <div class="template_dialog-item">{{item.guestName}}</div>
          <div class="template_dialog-item">{{item.guestCompany}}</div>
          <div class="template_dialog-item">{{item.guestDuty}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请日期</div>
          <div
            class="template_dialog-item"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList" :key="item.id">
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >{{item.name}}</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >
            <img v-if="signList.length>index+1" :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >签署日期</div>
          <div class="template_dialog-item" :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allow" :loading="dialogLoading">通 过</el-button>
        <el-button @click="noallow" :loading="dialogLoading">驳 回</el-button>
      </div>
    </el-dialog>
    <!--名片申请表-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template3"
      class="template_dialog"
      :visible="formShow===3"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>名片申请表</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">申请数量</div>
          <div class="template_dialog-item">{{templateContent.count}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">名片资料</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">姓名</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">职位</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">部门</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item">{{templateContent.chineseName}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item">{{templateContent.duty}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">中文</div>
          <div class="template_dialog-item">{{templateContent.department}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item">{{templateContent.englishName}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item">{{templateContent.englishDutyName}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">英文</div>
          <div class="template_dialog-item">{{templateContent.englishDepartmentName}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">直线电话</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">总机及分机电话</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">传真</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.telephone}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.zongji}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.fax}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">手机</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">E-mail</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">网址</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.phone}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.email}}</div>
        </div>
        <div class="template_col" style="width:33.33%">
          <div class="template_dialog-item">{{templateContent.website}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">备注</div>
          <div class="template_dialog-item left">{{templateContent.remark}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_gray">负责人签名</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >申请日期</div>
          <div
            class="template_dialog-item"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <span v-if="signList.length">{{signList[0].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <el-row v-for="(item,index) in detail.nodeUserIdsList" :key="item.id">
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >{{item.name}}</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >
            <img v-if="signList.length>index+1" :src="signList[index+1].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div
            class="template_dialog-item_title"
            :class="{last:detail.nodeUserIdsList.length-1===index}"
          >签署日期</div>
          <div class="template_dialog-item" :class="{last:detail.nodeUserIdsList.length-1===index}">
            <span v-if="signList.length>index+1">{{signList[index+1].date.replace('T', ' ')}}</span>
          </div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allow" :loading="dialogLoading">通 过</el-button>
        <el-button @click="noallow" :loading="dialogLoading">驳 回</el-button>
      </div>
    </el-dialog>
    <!--出差报告-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template7"
      class="template_dialog"
      :visible="formShow===7"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>出差报告</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">出差日期</div>
          <div
            class="template_dialog-item"
          >{{templateContent.startTime?(templateContent.startTime.split('T')[0] + ' 至 ' + templateContent.endTime.split('T')[0]):'-'}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_title">出差地点</div>
          <div class="template_dialog-item">{{templateContent.place}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">出差期间主要拜访人员</div>
          <div class="template_dialog-item">{{templateContent.seePeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">工作内容及工作成效</div>
          <div class="template_dialog-item">{{templateContent.content}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">下一步工作思路及拓展方向</div>
          <div class="template_dialog-item">{{templateContent.nextGoal}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question last">需要解决的问题、支持及建议</div>
          <div class="template_dialog-item last">{{templateContent.remark}}</div>
        </div>
      </el-row>
    </el-dialog>
    <!--工作周报-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template8"
      class="template_dialog"
      :visible="formShow===8"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>工作周报</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item">{{templateContent.time}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">凤凰卫视中文台、资讯台、电影台市场拓展</div>
          <div class="template_dialog-item">{{templateContent.fenghuangweishi}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">凤凰专区项目进展</div>
          <div class="template_dialog-item">{{templateContent.fenghuangzhuanqv}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">新业务拓展</div>
          <div class="template_dialog-item">{{templateContent.newTask}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question">与凤凰其他部门的合作及支持</div>
          <div class="template_dialog-item">{{templateContent.hezuo}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question last">管理中心交办事物</div>
          <div class="template_dialog-item last">{{templateContent.center}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_question last">行业动态及建议</div>
          <div class="template_dialog-item last">{{templateContent.suggest}}</div>
        </div>
      </el-row>
    </el-dialog>
    <!--呈批件-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template9"
      class="template_dialog"
      :visible="formShow===9"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>呈批件</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div
            style="height:200px;cursor:pointer"
            class="template_dialog-item_input"
            @click="changePishi"
          >
            <div class="template_dialog-item_text">批示：{{templateContent.pishi}}</div>
            <div class="template_dialog-item_sign">
              <span>签名：</span>
              <img :src="signList.length>=2 ? signList[1].signUrl:''">
            </div>
          </div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_input">题目：{{templateContent.topic}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div
            style="height:200px"
            class="template_dialog-item_input last"
          >内容：{{templateContent.content}}</div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pishiApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <!--备忘录-->
    <el-dialog :close-on-click-modal="false"
      @close="formShow = ''"
      width="740px"
      id="template10"
      class="template_dialog"
      :visible="formShow===10"
    >
      <div class="template_dialog-title" slot="title"><img class="tempalte_dialog-title_img" src="@/assets/black_icon.jpg"/>备忘录</div>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">呈送</div>
          <div class="template_dialog-item">{{templateContent.postPeople}}</div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">抄送</div>
          <div class="template_dialog-item">{{templateContent.copytoPeople}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">发件人</div>
          <div
            class="template_dialog-item_img"
            :class="{last:detail.nodeUserIdsList?detail.nodeUserIdsList.length===0:false}"
          >
            <img v-if="signList.length" :src="signList[0].signUrl">
          </div>
        </div>
        <div class="template_col" style="width:50%">
          <div class="template_dialog-item_title">日期</div>
          <div class="template_dialog-item">{{templateContent.createTime}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div
            style="height:200px;cursor:pointer"
            class="template_dialog-item_input"
            @click="changePishi"
          >
            <div class="template_dialog-item_text">批示：{{templateContent.pishi}}</div>
            <div class="template_dialog-item_sign">
              <span>签名：</span>
              <img :src="signList.length>=2 ? signList[1].signUrl:''">
            </div>
          </div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div class="template_dialog-item_input">题目：{{templateContent.topic}}</div>
        </div>
      </el-row>
      <el-row>
        <div class="template_col" style="width:100%">
          <div
            style="height:200px"
            class="template_dialog-item_input last"
          >内容：{{templateContent.content}}</div>
        </div>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pishiApply" :loading="dialogLoading">提 交</el-button>
        <el-button @click="formShow=''">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" class="pishi-dialog" title="编辑批示" width="740px" :visible.sync="pishiShow">
      <el-row>
        <el-input type="textarea" :rows="5" placeholder="请输入批示内容" v-model="pishi"></el-input>
      </el-row>
      <div v-if="detail.status===0" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPishi">确 认</el-button>
        <el-button @click="pishiShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import publicTopNav from "@/components/publicTopNav";
import getPdf from "@/utils/htmlToPdf.js";
import moment from "moment";
export default {
  components: {
    breadcrumb,
    publicTopNav
  },
  data() {
    return {
      pishi: "",
      sign: "",
      pishiShow: false,
      yesOrNo: 0,
      processList: [],
      detail: {},

      total: 0,
      params: {
        current: 1,
        pageSize: 10,
        searchName: "",
        status: ""
      },

      formShow: "",
      templateContent: {},
      signList: [],

      dialogLoading:false
    };
  },
  created() {
    this.getList();
  },
  filters: {
    leaveTypeFilter(v) {
      switch (v) {
        case 1:
          return "病假";
        case 2:
          return "事假";
        case 3:
          return "产假/陪产假";
        case 4:
          return "婚假";
        case 5:
          return "丧假";
      }
    }
  },
  methods: {
    getList() {
      axios
        .post(api.applyList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取审批列表成功", res.data.result);
            this.processList = res.data.result.records;
            this.total = res.data.result.total;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.error("网络错误，请稍后重试");
        });
    },
    showDetail(id) {
      axios
        .get(api.applyDetail + "/" + id)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取审批详情成功", res.data.result);
            this.detail = res.data.result;
            this.templateContent = JSON.parse(res.data.result.templateContent);
            this.signList = JSON.parse(res.data.result.signList) || [];
            this.formShow = res.data.result.templateId;
            if (this.detail.type === 2 && this.detail.status !== 3) {
              this.seeApply();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //批示完成
    pishiApply() {
      this.dialogLoading = true;
      setTimeout(() => {
        this.createdPdf(this.formShow);
      }, 100);
    },
    //通过
    allow() {
      this.dialogLoading = true;
      this.yesOrNo = 1;
      this.signList.push({
        signUrl: this.$store.state.userInfo.user.personalSignatureUrl,
        date: moment().format("YYYY-MM-DD hh:mm:ss")
      });
      if (this.detail.needUploadEndPdfFlag) {
        setTimeout(() => {
          this.createdPdf(this.formShow);
        }, 100);
      } else {
        this.approve();
      }
    },
    //驳回
    noallow() {
      this.dialogLoading = true;
       this.signList.push({
        signUrl: this.$store.state.userInfo.user.personalSignatureUrl,
        date: moment().format("YYYY-MM-DD hh:mm:ss")
      });
       setTimeout(() => {
          this.createdPdf(this.formShow);
        }, 100);
      this.yesOrNo = 2;
    },
    createdPdf(id) {
      let element = document.createElement("div");
      let template = document.getElementById(`template${id}`);
      element.style = "z-index:-100;position:fixed;width:800px;top:100%;";
      element.className = "el-dialog";
      element.appendChild(
        template.getElementsByClassName("el-dialog__header")[0].cloneNode(true)
      );
      element.appendChild(
        template.getElementsByClassName("el-dialog__body")[0].cloneNode(true)
      );
      template.appendChild(element);
      getPdf(this.detail.name, element).then(res => {
        template.removeChild(element);
        this.uploadPdf(res);
      });
    },
    //上传pdf
    uploadPdf(pdf) {
      let param = new FormData();
      param.append("file", pdf, pdf.name);
      param.append("fileType", 3);
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      axios
        .post(api.uploadFile, param, config)
        .then(res => {
          if (res.data.code === 0) {
            console.log("上传申请PDF成功", res.data.result);
            if (this.detail.type === 1) {
              this.approve(res.data.result[0]);
            } else {
              this.approvePishi(res.data.result[0]);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    approve(pdf) {
      let params = {
        fileUrlFinal: pdf || "",
        id: this.detail.id,
        signList: JSON.stringify(this.signList),
        yesOrNo: this.yesOrNo
      };
      axios
        .post(api.approve, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: `申请已${this.yesOrNo === 1 ? "通过" : "驳回"}`,
              type: "success"
            });
            this.formShow = "";
            this.dialogLoading = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg);
             this.dialogLoading = false;
          }
        })
        .catch(error => {
           this.dialogLoading = false;
          this.$message.error("网络错误，稍后重试");
        });
    },
    //批示类型的提交
    approvePishi(pdf) {
      let params = {
        fileUrlFinal: pdf || "",
        signList: JSON.stringify(this.signList),
        id: this.detail.id,
        templateContent: JSON.stringify(this.templateContent)
      };
      axios
        .post(api.pishi, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "批示提交成功",
              type: "success"
            });
            this.formShow = "";
            this.dialogLoading = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg);
              this.dialogLoading = false;
          }
        })
        .catch(error => {
            this.dialogLoading = false;
          this.$message.error("网络错误，稍后重试");
        });
    },
    changePage(v) {
      this.params.current = v;
      this.getList();
    },
    //已读
    seeApply() {
      let params = {id:this.detail.id}
      axios
        .post(api.see, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "已读",
              type: "success"
            });
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    changePishi() {
      if (this.detail.status === 0) {
        this.pishi = this.templateContent.pishi;
        this.pishiShow = true;
      }
    },
    submitPishi() {
      this.templateContent.pishi = this.pishi;
      this.signList.push({
        signUrl: this.$store.state.userInfo.user.personalSignatureUrl,
        date: moment().format("YYYY-MM-DD hh:mm:ss")
      });
      this.pishiShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.bussiness {
  .bussiness-wrap {
    padding: 77px 30px 0px 30px;
    .bussiness-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .bussiness-table-wrap {
        padding: 30px;
        .bussiness-table {
          min-height: 470px;
          tr {
            height: 47px;
            td {
              padding: 0px 19px;
              &:first-child {
                cursor: pointer;
                &:hover {
                  color: #f0722b;
                }
              }
              div {
                display: inline-block;
              }
            }
          }
        }
        .bussiness-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
  .template_dialog {
    .template_dialog-title {
       font-size: 26px;
      justify-content:center;
      font-weight: 600;
      display: flex;
      align-items: center;
      .tempalte_dialog-title_img{
        width:50px;
        height: 50px;
        margin-right: 10px;

      }
    }
    .el-row {
      display: flex;
    }
    .template_col {
      display: flex;
      &:last-child {
        border-right: 1px solid rgba(230, 227, 227, 1);
      }
    }
    .template_dialog-item,
    .template_dialog-item_title,
    .template_dialog-item_gray,
    .template_dialog-item_question,
    .template_dialog-item_input,
    .template_dialog-item_img {
      white-space: pre-line;
      font-size: 16px;
      min-height: 44px;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(230, 227, 227, 1);
      border-right: 0px;
      text-align: center;
      border-bottom: 0px;
      width: 100%;
      word-break: break-all;
      overflow-wrap: break-word;
      &.last {
        border-bottom: 1px solid rgba(230, 227, 227, 1);
      }
    }
    .left{
      justify-content: flex-start;
    }
    .template_dialog-item_img {
      padding: 0px;
      flex: 1;
      img {
        width: 100%;
        height: 44px;
        object-fit: contain;
      }
    }
    .template_dialog-item_input {
      flex: 1;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;
      .template_dialog-item_text {
        flex: 1;
        width: 100%;
        text-align: left;
        justify-content: flex-start;
        align-items: flex-start;
      }
      .template_dialog-item_sign {
        align-self: flex-end;
        display: flex;
        height: 60px;
        text-align: left;
        img {
          width: 150px;
          height: 50px;
          object-fit: contain;
        }
      }
    }
    .template_dialog-process {
      height: 180px;
      font-size: 16px;
      flex: 1;
      line-height: 180px;
      text-align: center;
      border: 1px solid rgba(230, 227, 227, 1);
      border-right: 0px;
    }
    .template_dialog-item {
      flex: 1;
    }
    .template_dialog-item_question {
      width: 300px;
      min-height: 100px;
    }
    .template_dialog-item_title {
      width: 110px;
    }
    .template_dialog-item_gray {
      background: #fafafa;
      flex: 1;
    }
  }
}
</style>
